export default __webpack_public_path__ + "static/media/Training_Materials.53148af6.png";